"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let navigator;
const setTopLevelNavigator = (navigatorRef) => {
    navigator = navigatorRef;
};
const getNavigation = () => navigator;
const navigate = (routeName, params = {}, isReset = false) => {
    const navigation = getNavigation();
    if (isReset) {
        return (navigation &&
            navigation.reset({
                index: 0,
                routes: [{ name: routeName, params }],
            }));
    }
    return navigation && navigation.navigate(routeName, params);
};
const canGoBack = () => getNavigation().canGoBack();
// Prevent hardware back if back options not available
// This prevents the app closing in Android
const handleHardwareBack = () => !canGoBack();
exports.default = {
    navigate,
    getNavigation,
    setTopLevelNavigator,
    canGoBack,
    handleHardwareBack,
};
